import { useContext } from 'react'

import filterContext from '@/components/pages/production/components/context'
import ListingsContext from '@/context/listings'
import { getHighestFilterPrice } from '@/utils/filters'

export const useLowestAndHighestListingsPrice = () => {
    const {
        selectors: { globalPriceRangeObject },
    } = useContext(ListingsContext)
    const { state: filterState } = useContext(filterContext)

    const highestPrice = getHighestFilterPrice(globalPriceRangeObject, filterState.showAllInPrice)
    const lowestPrice = filterState.showAllInPrice
        ? globalPriceRangeObject.lowestAllInPrice
        : globalPriceRangeObject.lowestPrice

    return [lowestPrice, highestPrice]
}
